import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';
import { Order } from 'src/app/common/Order';
import { OrderService } from 'src/app/services/order.service';
import { CommonModule, Location } from '@angular/common';
import { faWindowClose, faCheck } from '@fortawesome/free-solid-svg-icons';
import { AppProfileService } from 'src/app/services/profile.service';
import { ExtendedProfile } from 'src/app/common/ExtendedProfile';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { OrderPositionStatusDisplayNamePipe } from '../../pipes/order-position-status.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { OrderPositionStatusConstants } from '../../common/OrderPositionStatus';

@Component({
    imports: [CommonModule, PDFExportModule, OrderPositionStatusDisplayNamePipe, FontAwesomeModule],
    selector: 'app-order-buyer-edit',
    templateUrl: './order-buyer-edit.component.html'
})
export class OrderByuerEditComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  orderHistoryService = inject(OrderService);
  private location = inject(Location);
  private profileService = inject(AppProfileService);

  private destroyRef = inject(DestroyRef);

  OrderPositionStatusConstants = OrderPositionStatusConstants
  public showCancelButton = false;
  public id: string;
  public order: Order;
  public faCheck = faCheck;
  public faWindowClose = faWindowClose;
  public profile: ExtendedProfile = null;

  ngOnInit() {
    this.profileService.currentProfile$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((p) => {
      this.profile = p;
    });
    this.refresh();
  }

  onBackClicked() {
    this.location.back();
  }

  public onClaim(posId: string, orderId: string) {
    if (posId && orderId) {
      this.router.navigate(['/shop-order-claim-request'], {
        queryParams: { orderId: orderId, posId: posId },
      });
    }
  }

  private refresh() {
    this.order = new Order();
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.showCancelButton = Boolean(
      JSON.parse(this.activatedRoute.snapshot.queryParamMap.get('showCancelButton'))
    );

    this.orderHistoryService
      .getById(this.id)
      .pipe(take(1))
      .subscribe((res: Order) => {
        this.order = res;
      });
  }
}
